var map = {
	"./admin/UK/no_stint_shape_of_day.csv": [
		7798,
		7798
	],
	"./pizza_express/UK/no_stint_shape_of_day.csv": [
		3052,
		3052
	],
	"./pret/UK/no_stint_shape_of_day.csv": [
		7462,
		7462
	],
	"./sushi_dog/UK/no_stint_shape_of_day.csv": [
		2774,
		2774
	],
	"./tossed/UK/no_stint_shape_of_day.csv": [
		663,
		663
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7579;
module.exports = webpackAsyncContext;